import React, { Component } from "react";
import "./Boxes.scss";
export default class Boxes extends Component {
    render() {
        return (
            <section className="section section-boxes">
                <div className="padding">
                    <div className="container">
                        {/* <a href="https://z.ynet.co.il/fast/yfeed/?blogid=9" title="" target="_blank"><div className="box box-5"></div></a> */}
                        {/* <a href="https://electionsstories.ynet.co.il/" title="" target="_blank"><div className="box box-8"></div></a> */}
                        <a href="https://www.ynet.co.il/home/0,7340,L-13547,00.html" title="" target="_blank"><div className="box box-1"></div></a>
                        {/* <a href="https://www.ynet.co.il/home/0,7340,L-26712,00.html" title="" target="_blank"><div className="box box-2"></div></a> */}
                        {/* <a href="https://www.ynet.co.il/articles/0,7340,L-5450022,00.html" title="" target="_blank"><div className="box box-3"></div></a> */}
                        {/* <a href="https://electionguess.azurewebsites.net/#/" title="" target="_blank"><div className="box box-4"></div></a> */}
                        {/* <a href="https://z.ynet.co.il/short/content/electionchairs/" title="" target="_blank"><div className="box box-6"></div></a> */}
                        {/* <a href="https://vote2019.ynet.co.il/" title="" target="_blank"><div className="box box-7"></div></a> */}
                    </div>
                </div>
            </section>
        )
    }
}


// WEBPACK FOOTER //
// ./src/Components/Boxes/Boxes.jsx